/**
 * Converts the input string to a string containing only digits.
 *
 * @param {string} input - The input string to be processed.
 * @returns {string} A string containing only the digits from the input string.
 */
function toDigitsOnly(input) {
  const reDigits = /([^\d]+)/g;
  return input.replace(reDigits, "");
}

/**
 * Formats a phone number into a pretty format.
 *
 * @param {string} inputPhone - The input phone number as a string.
 * @returns {string} - The formatted phone number.
 */
export function formatPrettyPhone(inputPhone) {
  const filteredInput = toDigitsOnly(inputPhone);
  const reTelStr = /(?:(?<areacode>\d{0,3})(?:(?<prefix>\d{0,3})(?<linenumber>\d{0,4})?)?)?/g;
  const result = reTelStr.exec(filteredInput);

  if (!result?.groups) {
    return `${filteredInput.replace(/[^\d]/g, "")}`;
  }

  const { areacode = "", prefix = "", linenumber = "" } = result.groups;

  if (!prefix) {
    return `${areacode}`;
  } else if (!linenumber) {
    return `(${areacode}) ${prefix}`;
  }

  return `(${areacode}) ${prefix}-${linenumber}`;
}
